import { loadFirstFewRowsEstimates } from "components/jiffy/products/product-composition-estimates";
import initProductsGrid from "components/jiffy/product-card-v3/products-grid";

// Ensure DOM is ready (defer should handle this, but being defensive)
const initializeEstimates = () => {
  loadFirstFewRowsEstimates();

  // Initialize products grid for product-card-v3 if present on page
  if (document.querySelector(".js-product-card-v3")) {
    initProductsGrid();
  }
};

// If DOM is already loaded (defer guarantees this), run immediately
// Otherwise wait for DOMContentLoaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeEstimates);
} else {
  initializeEstimates();
}
